<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.review study version") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content">
  <div v-if="!versionList || versionList.length === 0" class="mt-5">
      <!-- <h4>{{ $t("navigations.there are currently no study versions available for reviewplease check back later or create a new study version to begin") }}</h4> -->
  <main class="d-flex align-items-center justify-content-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <div class="card shadow-sm text-center p-4">
            <div class="d-flex justify-content-center mb-3">
            <!-- Simple SVG illustration -->
              <svg class="card-illustration" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <rect x="6" y="10" width="52" height="40" rx="4" fill="#e9f5ff"/>
              <path d="M18 22h28M18 30h28M18 38h16" stroke="#3b82f6" stroke-width="2" stroke-linecap="round"/>
              <circle cx="48" cy="18" r="3" fill="#60a5fa"/>
              </svg>
            </div>
          
            <h6 class="card-title mb-2">{{ $t("navigations.there are currently no study versions available for review") }}</h6>
            <p class="text-muted mb-4">{{ $t("navigations.please check back later or create a new study version to begin") }}</p>
          
            <div class="d-flex justify-content-center gap-2">
            <a href="#" @click.prevent="goToCreateNewVersion()" class="btn btn-primary">{{ $t("navigations.add new study version") }}</a>
            </div>
          </div>
        </div>
      </div>
      </div>
  </main>
</div>
<div v-else>
  <div class="row">
    <div class="col-lg-12 px-2">
      <div class="mt-2 d-flex justify-content-between align-items-center mb-1" 
          v-if="rollsprivilages.includes('Studylist Edit')">

        <!-- Left Section: Title -->
        <h4 class="mb-0 sec-title">{{ $t("navigations.study information") }}</h4>

        <!-- Right Section: Edit + Versions Dropdown -->
        <div class="d-flex align-items-center">

          <!-- Versions Dropdown -->
          <div class="me-3">
            <label class="mb-0 me-2">{{ $t("navigations.version") }}</label>
            <select
              class="form-select form-select-sm d-inline-block w-auto py-0"
              v-model="selectedVersion"
              @change="onVersionChange"
            >
              <option v-for="ver in versionList" :key="ver" :value="ver">
                {{ ver }}
              </option>
            </select>
          </div>
          <div 
            class="me-3 approval assign-approver "
            v-if="showActivateBtn">
            <span class="pointer">Activate Study</span>
            <img
              src="../../assets/img/Activate_Study.png"
              alt="Assign Approver"
              @click="activateStudy()"
            />
          </div>
          <div 
            class="me-3 approval assign-approver "
            v-if="showApproveBtn" >
              <span class="pointer">Approve</span>
              <img
                src="../../assets/img/Approve_Study.png"
                alt="approval_status"
                @click="openApproveModal()"/>
          </div>
          <div class="me-3 approval assign-approver ">
            <span class="pointer">Assign Approver</span>
            <img
              src="../../assets/img/assign_approver.svg"
              alt="Assign Approver"
              :class="{ 'disabled-img': showLoading }"
              @click="!showLoading && openApprovalModal('approval')"
            />
          </div>
          <!-- Edit Icon -->
            <div class="me-3 approval assign-approver " >
              <span class="pointer">Edit</span>
            <img
              src="../../assets/img/Approve_Edit.png"
              alt="Edit study"
              :class="{ 'disabled-img': showLoading }"
              @click.prevent="studyEditModal = true"
            />
          </div>
        </div>
      </div>
    <!-- Study Details Section -->
     <div class="card px-2 py-1">
      <div class="row">
        <div class="col-sm-2 border-right">
          <small class="stats-label">{{ $t("navigations.study id") }}</small>
          <h4>{{ studyDetails.studyRef }}</h4>
        </div>
        <div class="col-sm-3 border-right">
          <small class="stats-label">{{ $t("navigations.name") }}</small>
          <h4>{{ studyDetails.studyName }}</h4>
        </div>
        <div class="col-sm-2 border-right">
          <small class="stats-label">{{ $t("navigations.sponsor") }}</small>
          <h4>{{ studyDetails.sponsor }}</h4>
        </div>
        <div class="col-sm-2 border-right">
          <small class="stats-label">{{ $t("navigations.expected no of sites") }}</small>
          <h4>{{ studyDetails.numberOfSite }}</h4>
        </div>
        <div class="col-sm-2 border-right">
          <small class="stats-label">{{ $t("navigations.expected no of patients") }}</small>
          <h4>{{ studyDetails.numberOfPatient }}</h4>
        </div>
        <div class="col-sm-1">
          <small class="stats-label">{{ $t("navigations.status") }}</small>
          <h4>{{ studyDetails.status }}</h4>
        </div>
      </div>
      </div>
    </div>
    <div class="col-lg-12 px-2">
      <div class="px-0">
        <div class="btn-group w-100 mt-2" v-if="isLatestVersionSelected">
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#importForms"
            v-if="rollsprivilages.includes('Visit Add Visit')"
            @click.prevent="showFormsModal = true"
          >
            <i class="fa fa-download mr-1"></i>
            <span class="bold">{{ $t("navigations.import forms") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            @click.prevent="soAPopup(0)"
            data-toggle="modal"
            data-target="#createTemplate"
          >
            <i class="fa fa-file-text-o mr-2"></i>
            <span class="bold">{{ $t("navigations.create activity") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createVisit"
            v-if="rollsprivilages.includes('Visit Add Visit')"
            @click.prevent="visitPopup(0, '')"
          >
            <i class="fa fa-map-marker mr-1"></i>
            <span class="bold">{{ $t("navigations.create visit") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createTemplate"
            v-if="rollsprivilages.includes('Visit Templates Create Template')"
            @click.prevent="createTemplate()"
          >
            <i class="fa fa-file-text-o mr-2"></i>
            <span class="bold">{{ $t("navigations.create form") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createTemplate"
            @click.prevent="privilegeform()"
          >
            <i class="fa fa fa-plus-square-o mr-2"></i>
            <span class="bold">{{ $t("navigations.add form privilege") }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="col-lg-12 wrapper wrapper-content px-2">
      <div class="card px-2 pb-2 pt-1">
      <h4>{{ $t("navigations.ecrf") }}</h4>
      <div class="text-center" v-if="ecrfLoading === true">
        <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
        />
        <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
        </div>
      </div>    
      <template v-else>
        <div class="text-center" v-if="studyTemplates.length==0">
            {{ $t('navigations.no data available') }}
        </div>   
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered ibox-body">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Category']" class="sort_block" @click="SortSelected('category', 5)" id="5">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.category") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Form Name']" class="sort_block" @click="SortSelected('templateName', 1)"
                  id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.form name") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Version']" class="sort_block" @click="SortSelected('version', 2)" id="2">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.version") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Language']" class="sort_block" @click="SortSelected('language', 3)" id="3">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.language") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Status']" class="sort_block" @click="SortSelected('status', 6)" id="6">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.status") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Last updated']" class="sort_block" @click="SortSelected('createdDate', 4)"
                  id="4">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.last updated") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                
                <th class="text-center" v-if="rollsprivilages.includes('Visit Templates View Template')">
                  {{ $t("navigations.view") }}
                </th>
                <th class="text-center">{{ $t("navigations.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(template, index) in studyTemplates" :key="template.id">
                <td v-if="selectedcolumnobj['Category']">
                  {{ template.category }}
                </td>
                <td v-if="selectedcolumnobj['Form Name']">
                  {{ template.templateName }}
                </td>
                <td v-if="selectedcolumnobj['Version']">
                  {{ template.version }}
                </td>
                <td v-if="selectedcolumnobj['Language']">
                  {{ template.language }}
                </td>
                 <td v-if="selectedcolumnobj['Status']">
                  {{ template.status }}
                </td>
                <td v-if="selectedcolumnobj['Last updated']">
                  {{ filterDate(template.createdDate) }}
                </td>
                
                <td class="text-center" v-if="rollsprivilages.includes('Visit Templates View Template')">
                  <a @click.prevent="
                    viewtemplatefun(template.templateId, template.version)
                    ">
                    <i class="fa fa-eye editicon"></i></a>
                </td>
                <td class="text-center" v-on:clickout="showSidePopup[index] = false">
                  <div class="position-relative cursor-pointer"
                    @click.prevent="showSidePopup[index] = !showSidePopup[index]">
                    <i class="fa fa-ellipsis-v"></i>
                  </div>
                  <div class="plan-side-popup" v-if="showSidePopup[index]">
                    <div v-if="
                      rollsprivilages.includes(
                        'Visit Templates Create New Version'
                      )
                    " @click.prevent="
                        createNewVersion(
                          template.templateFormId,
                          template.version,
                          template.sourceTemplateId,
                          template.templateId,
                          template.therapeuticAreaId,
                          template.categoryId
                        )
                        ">
                      {{ $t("navigations.create new version") }}
                    </div>
                    <div @click.prevent="
                      openCategoryModal(template.templateId, template.category)
                      ">
                      {{ $t("navigations.change category") }}
                    </div>
                    <div v-if="
                      rollsprivilages.includes('Visit Templates Retire Form')
                    " @click.prevent="
                        openretireModal(
                          template.sourceTemplateId,
                          template.version
                        )
                        ">
                      {{ $t("navigations.retire form") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-12 d-flex justify-content-lg-end px-0" v-if="studyTemplates.length!=0">
          <v-pagination v-model="currentTemplatePage" :pages="totalTemplatePages" :range-size="0" active-color="#f4f9ff"
            @update:modelValue="loadTemplate" />
        </div>
      </template>
      </div>
    </div>

    <div class="col-lg-6 wrapper wrapper-content px-2">
      <div class="card px-2 pb-2 pt-1">
      <h4>{{ $t("navigations.activities") }}</h4>
       <div class="text-center" v-if="activitiesLoading === true">
        <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
        />
        <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
        </div>
      </div>    
      <template v-else>
        <div class="text-center" v-if="SoAList.length==0">
            <i class="fa fa-list display-6 text-muted mb-3 mt-3"></i>
          <h6 class="text-muted mb-1">{{ $t('navigations.no activities created') }}</h6>
          <p class="text-muted mb-4">{{ $t('navigations.activities help you organize data collection procedures in your study') }}</p>
        </div>   
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered ibox-body">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Activity Name']" class="sort_block"
                  @click="SortActivities('activityName', 8)" id="8">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.activity name") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Activity Type']" class="sort_block"
                  @click="SortActivities('activityType', 9)" id="9">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.activity type") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['View Form']" class="sort_block" @click="SortActivities('viewForms', 10)"
                  id="10">
                  <div class="text-center">{{ $t("navigations.view forms") }}</div>
                </th>
                <th class="text-center">{{ $t("navigations.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in SoAList" :key="item.id">
                <td v-if="selectedcolumnobj['Activity Name']">
                  {{ item.activityName }}
                </td>
                <td v-if="selectedcolumnobj['Activity Type']">
                  {{ item.activityType }}
                </td>
                <td class="text-center"  v-if="selectedcolumnobj['View Form']">
    <a href="#" @click.prevent="openActivityFormsModal(item.id)">
      <i class="fa fa-eye editicon"></i>
    </a>
    {{ item.templateName }}
  </td>
                <td class="text-center" v-on:clickout="showSoaPopup[index] = false">
                  <div class="position-relative cursor-pointer"
                    @click.prevent="showSoaPopup[index] = !showSoaPopup[index]">
                    <i class="fa fa-ellipsis-v"></i>
                  </div>
                  <div class="plan-side-popup" v-if="showSoaPopup[index]">
                    <div @click.prevent="deleteSoA(item.id, index)">
                      {{ $t("navigations.delete") }}
                    </div>
                    <div @click.prevent="soAPopup(item.id)">
                      {{ $t("navigations.edit") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-12 d-flex justify-content-lg-end px-0" v-if="SoAList.length!=0">
          <v-pagination v-model="soaCurrentPage" :pages="soaTotalPages" :range-size="0" active-color="#f4f9ff"
            @update:modelValue="loadSoA" />
        </div>
      </template>
      </div>
    </div>

    <div class="col-lg-6 wrapper wrapper-content px-2">
      <div class="card px-2 pb-2 pt-1">
      <h4>{{ $t("navigations.visits") }}</h4>
          <div class="text-center" v-if="visitsLoading === true">
      <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
      />
      <div>
          {{ $t("navigations.please wait while the list is being loaded") }}
      </div>
      </div>    
      <template v-else>
        <div class="text-center" v-if="visitList.length==0">
          <i class="fa fa-calendar display-6 text-muted mb-3 mt-3"></i>
          <h6 class="text-muted mb-1">{{ $t('navigations.no visits scheduled') }}</h6>
          <p class="text-muted mb-4">{{ $t('navigations.visits represent timepoints in your study when data is collected') }}</p>
        </div>   
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered ibox-body">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Visit No']" class="sort_block" @click="SortVisit('visitNo', 7)" id="7">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.visit no") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Visit Name']" class="sort_block" @click="SortVisit('visitFormName', 6)"
                  id="6">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.visit name") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>             
                <th class="text-center">{{ $t("navigations.visit activity") }}</th>
                <th class="text-center">{{ $t("navigations.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(visit, index) in visitList" :key="visit.visitId">
                <td v-if="selectedcolumnobj['Visit No']">{{ visit.visitNo }}</td>
                <td v-if="selectedcolumnobj['Visit Name']">
                  {{ visit.visitFormName }}
                </td>             
                <td class="text-center">
                  <i class="fa fa-clock-o edit-delete" @click.prevent="openVisitActivityModal(visit.visitId)"></i>
                </td>
                <td class="text-center" v-on:clickout="showVisitPopup[index] = false">
                  <div class="position-relative cursor-pointer" @click.prevent="
                    showVisitPopup[index] = !showVisitPopup[index]
                    ">
                    <i class="fa fa-ellipsis-v"></i>
                  </div>
                  <div class="plan-side-popup" v-if="showVisitPopup[index]" :id="`visit-${visitId}`">
                    <div v-if="rollsprivilages.includes('Visit Delete')" @click.prevent="deleteVist(visit.visitId)">
                      {{ $t("navigations.delete") }}
                    </div>
                    <div v-if="rollsprivilages.includes('Visit Edit')" @click.prevent="
                      visitPopup(visit.visitId, `visit-${visitId}`)
                      ">
                      {{ $t("navigations.edit") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-12 d-flex justify-content-lg-end px-0" v-if="visitList.length!=0">
          <v-pagination v-model="currentVisitiPages" :pages="totalVisitPages" :range-size="0" active-color="#f4f9ff"
            @update:modelValue="loadVisit" />
        </div>
      </template>
      </div>
    </div>
  </div>
  <teleport to="#wrapper">
    <managePatientModal v-if="showPatientModal" @closeModal="showPatientModal = false" :patientId="0" />
  </teleport>
  <importForms 
    v-if="showFormsModal" 
    :studyVersion="selectedVersion"
    @closeModal="showFormsModal = false" 
    @importForms="listStudyTemplate()" />
  <manageVisitModal 
    v-if="showSiteModal" 
    :visitId="visitId" 
    :version="selectedVersion"
    @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal" 
  />
  <manageSoAModal 
    v-if="showSoAModal" 
    :soAId="activityId" 
    :studyId="studyDetails.studyId" 
    :studyVersion="selectedVersion"
    :studyRef="studyDetails.studyRef"
    @closeSoAModal="closeSoAModal()" @refreshActivities="listSOAs" />
  <CreateSitePopUp v-if="siteModal" :userid="'0'" @closeModal="siteModal = false" />
  <EditStudyPopUp v-if="studyEditModal" :studyid="studyId" :selectedversion="selectedVersion" @studyChanged="getStudyDetails()"
    @closeModal="studyEditModal = false" />
  <createnewversion v-if="creatversionpopup == true" @closedialogebox="closecreatenewversion()"
    @createnewtempversion="newtemplateversion()" :templateId="currenttemplateId" :currentversion="currentformversion"
    :formid="newversionformid" />
  <retireFormPopUp v-if="retireFormModal" @closeModal="closeRetireModal()" :sourceid="sourceId"
    :version="sourceVersion" />
  <ChangeCategory v-if="showcategoryModal" :templateId="selectedTemplateId" :selectedCategory="selectedCategory"
    @closeModal="closeCategoryModal()" />
  <teleport to="#wrapper">
    <!-- Template modal starts -->
    <div class="study_profile_modal__wrapper" v-if="showAssignTemplate">
      <div class="study_profile_modal__container custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-2 px-2">
          <h4 class="my-0">{{ $t("navigations.assign form") }}</h4>

          <div class="tooltip-wrapper pointer" @click.prevent="closeTemplateModal()"
            style="float:right">
            <i class="fa fa-times cursor-pointer"></i>
           <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="modal-body">
          <div>
            <div class="form-group row my-lg-2">
              <div class="d-flex justify-content-center">
                <div class="col-lg-10 pl-0 pr-1">
                  <Multiselect v-model="selectedTemplateIds" mode="multiple" :searchable="true"  trackBy="templateName" valueProp="templateId"
                    placeholder="Select Form" label="templateName" :options="templatelist" :hideSelected="false"
                    :closeOnSelect="false" class="multiselect-template-theme mr-0">
                    <template v-slot:option="{ option }">
                      {{ option.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                    </template>
                  </Multiselect>
                </div>
                <div class="col-lg-2 px-0">
                  <button class="save_btn py-1 w-100" @click.prevent="assignTemplate()">
                    {{ $t("navigations.assign") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </teleport>
  <teleport to="#wrapper">
    <!-- Template modal starts -->
    <div class="study_profile_modal__wrapper" v-if="addPrivilegeModal">
      <div class="study_profile_modal__container PrivilegeModal-custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-2 px-3">
          <h4 class="my-0">{{ $t("navigations.add form privilege") }}</h4>

          <div class="tooltip-wrapper pointer" @click.prevent="closePrivilege()" style="float: right; cursor: pointer">
            <i class="fa fa-times"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group row my-lg-2 d-flex">
            <div class="col-lg-6">
              {{ $t('navigations.select forms') }}
              <Multiselect v-model="selectedTemplateIds" mode="multiple"  :searchable="true"  trackBy="templateName" valueProp="templateId"
                placeholder="Select Template" label="templateName" :options="templates" :hideSelected="false"
                :closeOnSelect="false" class="multiselect-template-theme mr-0 mt-1" @change="onTemplateChange">
              </Multiselect>
            </div>
            <div class="col-lg-6">
              Select Roles
              <Multiselect v-model="selectedRoleList" mode="multiple" :searchable="true"  trackBy="roleName" valueProp="roleID" placeholder="Select Role"
                label="roleName" :options="roleList" :hideSelected="false" :closeOnSelect="false"
                class="multiselect-template-theme mr-0 mt-1" @change="onRoleChange">
              </Multiselect>
            </div>
          </div>
          <div class="table-responsive" style="max-height: 300px; overflow-y: auto">
            <table class="table table-striped table-bordered table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Role</th>
                  <th scope="col">e-CRF</th>
                  <th scope="col">
                    Add
                    <br />
                    <input type="checkbox" :checked="isAllSelected('Add')" @change="toggleColumn('Add', $event)" />
                  </th>
                  <th scope="col">
                    Edit
                    <br />
                    <input type="checkbox" :checked="isAllSelected('Edit')" @change="toggleColumn('Edit', $event)" />
                  </th>
                  <th scope="col">
                    View
                    <br />
                    <input type="checkbox" :checked="isAllSelected('View')" @change="toggleColumn('View', $event)" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in privilegeRows" :key="row.roleId + '-' + row.templateId">
                  <td>{{ row.roleName }}</td>
                  <td>{{ row.templateName }}</td>
                  <td>
                    <input type="checkbox" :checked="rolesAndPrivilegelist[row.roleId][
                        row.templateId
                      ].includes('Add')
                      " @change="onPrivilegeChange(row, 'Add', $event)" value="Add" />
                  </td>
                  <td>
                    <input type="checkbox" :checked="rolesAndPrivilegelist[row.roleId][
                        row.templateId
                      ].includes('Edit')
                      " @change="onPrivilegeChange(row, 'Edit', $event)" value="Edit" />
                  </td>
                  <td>
                    <input type="checkbox" :checked="rolesAndPrivilegelist[row.roleId][
                        row.templateId
                      ].includes('View')
                      " @change="onPrivilegeChange(row, 'View', $event)" value="View" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12 text-center py-2">
            <button v-if="addPrivilegebutton" class="save_btn py-1" :disabled="isCreating"
              @click.prevent="createFormPrivilege()">
              <span v-if="isCreating" class="spinner-border spinner-border-sm me-2" role="status"
                aria-hidden="true"></span>
              {{
                isCreating
                  ? $t("creating…")
                  : $t("navigations.create privilege")
              }}
            </button>
            <!-- <button
              v-else
              class="save_btn py-1"
              @click.prevent="updateFormPrivilege()"
            >
              {{ $t("navigations.update privilege") }}
            </button> -->
            <button v-else class="save_btn py-1" :disabled="isUpdating" @click.prevent="updateFormPrivilege()">
              <span v-if="isUpdating" class="spinner-border spinner-border-sm me-2" role="status"
                aria-hidden="true"></span>
              {{
                isUpdating
                  ? $t("updating…")
                  : $t("navigations.update privilege")
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </teleport>
  <Forms_AI_PopUp v-if="AIpopup" @studyCreated="loadstudy" @closeModal="AIpopup = false" />
  <!-- List visit forms modal starts -->
  <Teleport to="#wrapper">
    <div class="study_profile_modal__wrapper" v-if="showVisitForms">
      <div class="study_profile_modal__container custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-1 px-3">
          <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
          <div class="col-lg-2">
           <span class="tooltip-wrapper pointer" style="float:right">
              <i class="fa fa-times cursor-pointer" @click.prevent="closeModalForms"></i>
               <span class="custom-tooltip  closetooltipposition">Close</span>
 
            </span>
          </div>
        </div>
        <div class="modal-body overflow-block-form scroll_horizontal">
          <!-- test -->
          <div>
            <div class="form-group row my-lg-2">
              <div class="d-flex flex-column flex-lg-row mb-lg-0">
                <div class="col-lg-12 ">
                  <table class="table features-table">
                    <p v-if="formItems == ''" class="mb-0 text-center">
                      {{ $t("navigations.no forms added") }}
                    </p>
                    <tbody>
                      <tr v-for="forms in formItems" :key="forms.id">
                        <td>{{ forms.templateName }} ({{ forms.version }}) - {{ forms.languageCode.toUpperCase() }}</td>
                        <td class="text-center">
                          <i class="fa fa-eye edit-delete" @click.prevent="viewForm(forms.template_ID)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- test -->
        </div>
      </div>
    </div>
  </Teleport>
   <Teleport to="#wrapper">
  <div class="study_profile_modal__wrapper" v-if="showActivityForms">
    <div class="study_profile_modal__container custom-width mt-5">
      <div class="modal__title d-flex justify-content-between py-1 px-3">
        <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
        <div class="closebutton">
            <span class="tooltip-wrapper pointer" style="float:right">
            <i class="fa fa-times cursor-pointer" @click.prevent="closeActivityForms"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        
        </div>
      </div>

      <div class="modal-body overflow-block-form scroll_horizontal">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12">
            <table class="table features-table">
  <p v-if="!soAItem.eCRF || soAItem.eCRF.length === 0" class="mb-0 text-center">
    {{ $t("navigations.no forms added") }}
  </p>
  <tbody>
    <tr v-for="(form, index) in soAItem.eCRF" :key="index">
      <td>{{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}</td>
      <td class="text-center">
        <i class="fa fa-eye edit-delete" @click.prevent="gotoform(form.templateId)"></i>
      </td>
    </tr>
  </tbody>
</table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Teleport>

  <!-- End of list visit forms modal -->

  <!-- Activityorder popup starts -->
  <VisitActivityModal 
    v-if="showActivityModal"
    :visitId ="SelectedVisitId"
    :version= "selectedVersion"
     @closeModal="showActivityModal = false"
  />
  <ActivityFormTemplate 
    v-if="showActivityFormModal"
    :activityId="selectedActivityId"
    @closeModal="showActivityModal = false"
  />
  <showformmodel
    v-if="setshowActivityFormModal"
    :formid="currentform"
    currentformstatus="not completed"
    @closeformModal="closeformActivityModal()"
  />
  <customModal
    v-if="documentApprovalModal"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeDocumentApprovalModal()"
  >
    <template #title>
      {{ $t("navigations.assign approver") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">{{ $t("navigations.choose role") }}</label>
          <Multiselect
            v-model="designationList"
            mode="multiple"
            :searchable="true"
            trackBy="roleName"
            valueProp="roleID"
            placeholder="Select"
            label="roleName"
            :options="roleList"
            :hideSelected="false"
            :closeOnSelect="false"
            class="multiselect-template-theme mr-0 mt-1"
            @change="onChange"
           
          />
        </div>

      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
               <input
                  class="mr-1"
                  type="checkbox"
                  id="selectAllDocumentApprovers"
                  @change="selectall"
                />
                Users
              </th>
              <th></th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in userList" :key="user.id">
              <td width="50%">
                <input
                    type="checkbox"
                    :id="user.userID"
                    v-model="isSelectedUser[index]"
                    :disabled="isDisabled[index]"
                />
                <label class="mb-0" :for="user.userID">{{ user.name }}</label>
              </td>
              <td width="30%">
               <input
                  class="mr-1"
                  type="checkbox"
                  :id="'required-' + index"
                  v-model="isRequired[index]"
                  :disabled="isDisabled[index]"
                />
                <label class="mb-0" :for="isRequired[index]">
                  {{ $t("navigations.required") }}
                </label>
              </td>
              <td width="20%" class="text-center">
                <button
                  @click.prevent="singleSaveApprover(user, index)"
                  :disabled="isDisabled[index]"
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  :class="{
                    'disabled-btn-cls': loadingSingleSave[index] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingSingleSave[index] == false,
                      'opacity-1': loadingSingleSave[index] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingSingleSave[index] == false,
                      'opacity-0': loadingSingleSave[index] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="modal-footer d-flex justify-content-between">
        <label >
          *Unsaved changes will be lost if switching roles.</label
        >

        <button
          
          type="button"
          class="save_btn py-1 px-3 position-relative"
          @click="multipleSaveApprover()"
        >
          Save
        </button>
      </div> -->
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
       
      >
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multipleSaveApprover()"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.assign") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
  <ApproveRejectPopUp
    v-if="showApproveRejectPopup"
    :actionType="'Approval'"
    :itemId="studyId"
    :version="selectedVersion"
    @closeApproveModal="closeApproveModal()"
  />
    </div>
  </div>
</template>

<script src="./createNewVersion.js"/>

<style scoped>
.btn-success {
  background-color: transparent;
  border-color: var(--secondary-clr);
  border-radius: 0;
  font-size: 0.8rem;
}

.btn-success:hover,
.btn-success:focus {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn {
  padding-block: 0.2rem;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 56px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}
.closetooltipposition{
  bottom: -10px !important;
  margin-left: -75px !important;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  border-radius: 4px;
  background: #fff;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  border: 0px;
  border-radius: 4px 4px 0px 0px;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.float-right:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.custom-width {
  width: min(500px, 90%);
}

.PrivilegeModal-custom-width {
  width: min(900px, 90%);
}

.modal-wrapper-forms {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 3000;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  margin: 0;
  padding: 5%;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}
.closetooltipposition{
  bottom: -10px !important;
  margin-left: -75px !important;
}


.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.scroll_horizontal {
  height: 400px;
  overflow: auto;
}
.approval {
  position: relative;
  display: inline-block;
}

.approval .pointer {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.6rem;
  font-size: 0.7rem;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-100%) translateY(-2px);
  white-space: nowrap;
  z-index: 10;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}

.approval:hover .pointer {
  visibility: visible;
  opacity: 1;
}
.card-illustration {
        width: 120px;
        height: 120px;
      }
.btn-group >.btn{
  font-size: .8rem;
  font-weight:400px;
  border-radius: 4px !important;
  border-color: var(--primary-clr);
}
.card h4{
  font-size:13px !important;
  font-weight: 600;
}
.sec-title{
  font-size:13px !important;
  font-weight: 600;
}
</style>